module.exports = __webpack_public_path__ + "media/newUser1.ebd9b9c2.mp3";